import { createSlice } from '@reduxjs/toolkit';
import { fetchRelatedSearchesForSearchPage } from './relatedSearches.actions';
import { RelatedSearchItem } from './relatedSearches.types';
import { submitSearch } from '../search.actions';

export type RelatedSearchesSlice = {
    suggestions: RelatedSearchItem[];
};

export const defaultRelatedSearchesSlice: RelatedSearchesSlice = {
    suggestions: [],
};

const initialState = defaultRelatedSearchesSlice;

const relatedSearchesSlice = createSlice({
    extraReducers: (builder) => {
        builder
            .addCase(fetchRelatedSearchesForSearchPage.fulfilled, (state, action) => {
                state.suggestions = action.payload;
            })
            .addCase(fetchRelatedSearchesForSearchPage.rejected, (state, action) => {
                console.error('fetchRelatedSearchesForSearchPage failed', action.error);
                state.suggestions = [];
            })
            .addCase(submitSearch.fulfilled, (state) => {
                state.suggestions = [];
            });
    },
    initialState,
    name: 'relatedSearches',
    reducers: {
        setRelatedSearchSuggestions: (state, action: { payload: RelatedSearchItem[] }) => {
            state.suggestions = action.payload;
        },
    },
});

export const { setRelatedSearchSuggestions } = relatedSearchesSlice.actions;
export const relatedSearchesReducer = relatedSearchesSlice.reducer;
